import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Login } from "@/pages/Login";
import { ResetPassword } from "@/pages/ResetPassword";
import { Profile } from "@/pages/Profile";
import { Leads } from "@/pages/Leads";
import { ProductLeads } from "@/pages/ProductLeads";
import { ProductClicks } from "@/pages/ProductClicks";
import { Loans } from "@/pages/Loans";
import { LoanDetail } from "@/pages/LoanDetail";
import { SubAgents } from "@/pages/SubAgents";
import { CustomerProfile } from "@/pages/CustomerProfile";
import { Products } from "@/pages/Products";
import { ProductDetail } from "@/pages/ProductDetail";
import { Resources } from "@/pages/Resources";
import { VoiceCalls } from "@/pages/VoiceCalls";
import { WhiteLabelling } from "@/pages/WhiteLabelling";
import { useSessionTimeout } from "@/hooks/useSessionTimeout";
import { getBranding } from "@/utils/branding";

/**
 * Separated from AppRouter because hooks must be called inside BrowserRouter.
 */
const AppRoutes: React.FC = () => {
  useSessionTimeout();

  return (
    <Routes>
      <Route path="/agent-login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      {/* Dashboard removed — default landing is Products catalog */}
      <Route path="/" element={<Navigate to="/products" replace />} />
      <Route path="/leads" element={<Leads />} />
      <Route path="/product-leads" element={<ProductLeads />} />
      <Route path="/product-clicks" element={<ProductClicks />} />
      <Route path="/loans" element={<Loans />} />
      <Route path="/loans/:loanId" element={<LoanDetail />} />
      <Route path="/sub-agents" element={<SubAgents />} />
      <Route path="/products" element={<Products />} />
      <Route path="/products/:productId" element={<ProductDetail />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/resources" element={getBranding() ? <Navigate to="/products" replace /> : <Resources />} />
      <Route path="/voice-calls" element={<VoiceCalls />} />
      <Route path="/white-labelling" element={<WhiteLabelling />} />
      <Route path="/customer/:customerId" element={<CustomerProfile />} />
      <Route path="*" element={<Navigate to="/products" replace />} />
    </Routes>
  );
};

const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
};

export default AppRouter;
